import React, { useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import CompanySearchBar from './CompanySearchBar.jsx';
import CompanyNewOrEditModal from './CompanyNewOrEditModal.jsx';
import LoginButton from '../auth0/loginButton.jsx';
import LogoutButton from '../auth0/logoutButton.jsx';
import cce_logo from '../../assets/images/cce_logo.png';
import {
  Navbar,
  NavbarToggler,
  NavItem,
  NavbarBrand,
  Collapse,
  Row,
  Col
} from 'reactstrap';

const CompanyLayout = (props) => {
  const { isAuthenticated, isLoading } = useAuth0();

  let rightSection;
  if (isAuthenticated) {
    rightSection = <LogoutButton style={{fontSize:'12px'}} />;
  } else if (!isLoading) {
    rightSection = <LoginButton style={{fontSize:'12px'}} />;
  }

  const [collapsed, setIsCollapsed] = useState(false);

  const toggleNavbar = () => {
    if (window.innerWidth >= 992) {
      return;
    }
    setIsCollapsed(!collapsed);
  }

  return (
    <div>
      <Navbar fixed="top" color="white" className="navbar-expand-lg card-box">
        <NavbarBrand className="mr-auto">
          <img
            alt={"CCE"}
            src={cce_logo}
            height={48} />
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr2">
          <i className="ion-navicon" />
        </NavbarToggler>
        <Collapse isOpen={collapsed} navbar>
          <NavItem className="company-search-bar">
            <Row>
              <Col xs={10}>
                <CompanySearchBar {...props} />
              </Col>
              <Col xs={1}>
                {
                  isAuthenticated ?
                  <CompanyNewOrEditModal /> :
                  null
                }
              </Col>
              <Col xs={1}>
                {rightSection}
              </Col>
            </Row>
            <Row className="company-nav-text">
              Base de datos de empresas confiables respaldadas por
              &nbsp;
              <a href="https://www.cidemipymes.com.mx/#section-about" target="_blank" rel="noopener noreferrer">
                CIDEMiPyMe
              </a>
              &nbsp;
              y
              &nbsp;
              <a href="https://www.cidemipymes.com.mx/#section-methodologies" target="_blank" rel="noopener noreferrer">
                Círculo de Crecimiento Empresarial
              </a>
              &nbsp;
            </Row>
          </NavItem>
          <NavItem className="company-new-item-btn">
          </NavItem>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default CompanyLayout;
